/*
 * ============================================================
 * argile-locations.js — « Emplacements » : image liée aux implantations
 * ============================================================
 * Chargé PAR la section (cf. sections/argile-locations.liquid).
 *
 * Cible `[data-argile-locations]`. Au clic (ou flèches haut/bas) sur le nom d'une
 * implantation `[data-location-trigger]`, l'image `data-image` de son item
 * `[data-location]` alimente la grande image partagée `[data-location-stage]`
 * (cross-fade via la classe .is-ready). La première implantation est active au chargement.
 */
(function () {
  'use strict';

  function initLocations(root) {
    var scope = root || document;
    var groups = scope.querySelectorAll('[data-argile-locations]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      if (group.dataset.argileWired) return;
      group.dataset.argileWired = '1';

      var stage = group.querySelector('[data-location-stage]');
      var items = [].slice.call(group.querySelectorAll('[data-location]'));
      if (!items.length) return;

      var triggers = items.map(function (item) {
        return item.querySelector('[data-location-trigger]');
      });

      function setStage(item) {
        if (!stage) return;
        var src = item.getAttribute('data-image');
        if (!src) return;
        stage.classList.remove('is-ready');
        var pre = new Image();
        pre.onload = function () {
          stage.src = src;
          stage.alt = item.getAttribute('data-alt') || '';
          stage.classList.add('is-ready');
        };
        pre.src = src;
      }

      function activate(index, focus) {
        items.forEach(function (item, i) {
          var on = i === index;
          item.classList.toggle('is-active', on);
          var trigger = triggers[i];
          if (trigger) {
            trigger.setAttribute('aria-selected', on ? 'true' : 'false');
            trigger.tabIndex = on ? 0 : -1;
            if (on && focus) trigger.focus();
          }
        });
        setStage(items[index]);
      }

      // Toute l'implantation est cliquable pour changer l'image — mais on laisse
      // les liens internes (téléphone, « Prendre rendez-vous ») fonctionner.
      items.forEach(function (item, i) {
        item.addEventListener('click', function (event) {
          if (event.target.closest('a')) return;
          activate(i, false);
        });
      });

      group.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        var current = triggers.indexOf(document.activeElement);
        if (current < 0) return;
        event.preventDefault();
        var next = event.key === 'ArrowDown'
          ? (current + 1) % triggers.length
          : (current - 1 + triggers.length) % triggers.length;
        activate(next, true);
      });

      // Première implantation avec une image active au chargement.
      var firstWithImage = items.findIndex(function (item) {
        return item.getAttribute('data-image');
      });
      activate(firstWithImage < 0 ? 0 : firstWithImage, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initLocations(document); });
  } else {
    initLocations(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initLocations(event.target);
  });
})();
